import { Entity } from "@backstage/catalog-model";
import { DefaultEntityFilters, EntityFilter, EntityKindFilter, EntityTypeFilter, useEntityList } from "@backstage/plugin-catalog-react";
import { FormControl, Typography, FormGroup, FormControlLabel, Checkbox, Radio, RadioGroup, Divider } from "@material-ui/core";
import React, { useState } from "react";

// class CustomKindsFilter implements EntityFilter {
//     constructor(readonly values: string[]) { }
//     filterEntity(entity: Entity): boolean {
//         const tier = entity.metadata.annotations?.['company.com/security-tier'];
//         return tier !== undefined && this.values.includes(tier);
//     }
// }
// export type CustomFilters = DefaultEntityFilters & {
//     securityTiers?: CustomKindsFilter;
// };

export const CustomKindsPicker = () => {
    // The securityTiers key is recognized due to the CustomFilter generic
    const {
        filters,
        updateFilters,
    } = useEntityList<DefaultEntityFilters>();

    const [selectedKind, setSelectedKind] = useState("system")

    // Toggles the value, depending on whether it's already selected
    function onChange(value: string) {
        setSelectedKind(value);
        // Dirty solution: needs refactor
        switch (value) {
            case "system":
                updateFilters({ kind: new EntityKindFilter("system", "Product"), type: undefined });
                break;
            case "component":
                updateFilters({ kind: new EntityKindFilter("component", "Component"), type: undefined });
                break;
            case "resource":
                updateFilters({ kind: new EntityKindFilter("resource", "Resource"), type: undefined });
                break;
            case "api":
                updateFilters({ kind: new EntityKindFilter("api", "API"), type: undefined });
                break;
            case "group":
                updateFilters({ kind: new EntityKindFilter("group", "Group"), type: new EntityTypeFilter(["ProductTeam"]) });
                break;
            case "domain":
                updateFilters({ kind: new EntityKindFilter("domain", "Domain"), type: new EntityTypeFilter(["Domain"]) });
                break;
            case "subdomain":
                updateFilters({ kind: new EntityKindFilter("domain", "Sub-domain"), type: new EntityTypeFilter(["SubDomain"]) });
                break;
            case "application":
                updateFilters({ kind: new EntityKindFilter("component", "Application"), type: new EntityTypeFilter(["Application"]) });
                break;
            case "repo":
                updateFilters({ kind: new EntityKindFilter("resource", "Repository"), type: new EntityTypeFilter(["ADO Repository"]) });
                break;
            case "azsub":
                updateFilters({ kind: new EntityKindFilter("resource", "azuresubscription"), type: new EntityTypeFilter(["azuresubscription"]) });
                break;
        }
    }

    const indented: React.CSSProperties = { marginLeft: "0px" };

    return (
        <FormControl component="fieldset" style={{ width: "100%" }}>
            <Typography variant="button">Kinds</Typography>
            <FormGroup>
                <RadioGroup aria-label="gender" name="gender1" value={selectedKind} onChange={(_, v) => onChange(v)}>
                    <FormControlLabel value="domain" control={<Radio />} label="Domains" />
                    <FormControlLabel value="subdomain" control={<Radio />} label="Sub-domains" />
                    <FormControlLabel value="group" control={<Radio />} label="Product Teams" />
                    <FormControlLabel value="system" control={<Radio />} label="Products" />
                    <Divider />
                    <FormControlLabel value="component" control={<Radio />} label="All Components" />
                    <FormControlLabel value="application" control={<Radio />} label="Applications" style={indented} />
                    <FormControlLabel value="api" control={<Radio />} label="APIs" style={indented} />
                    <Divider />
                    <FormControlLabel value="resource" control={<Radio />} label="All Resources" />
                    <FormControlLabel value="repo" control={<Radio />} label="Code Repositories" style={indented} />
                    <FormControlLabel value="azsub" control={<Radio />} label="Azure Subscriptions" style={indented} />
                </RadioGroup>
            </FormGroup>
        </FormControl>
    );
};